import React, {
  forwardRef,
  useState,
  useEffect,
  useImperativeHandle,
} from "react";
import { useNavigate } from "react-router-dom";
// Components
import {
  AutoComplete,
  Form,
  message,
  Row,
  Col,
  Flex,
  Button,
  Input,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import StepsHeading from "./StepsHeading";
import {
  AddItemButton,
  CustomInput,
  CustomButton,
  CustomModal,
  Map,
} from "../../../components";
import { useToken } from "../../../common/helper";
import { useSpin } from "../../../components/SpinContext.js";
import { GetLocations, AddLocations } from "../../../api's/onboarding.js";
import EditLocation from "../../../assets/images/edit_location.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllLocations,
  selectLocationState,
} from "../../../reudx-toolkit/slice/LocationSlice";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js";

const Locations = forwardRef(({ onNext, onSuccess }, ref) => {
  const [locationForm] = Form.useForm();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalName, setModalName] = useState("");
  const [selectedLatLng, setSelectedLatLng] = useState(null);
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [polygonIndex, setPolygonIndex] = useState(-1);
  const [polygon, setPolygon] = useState();
  const [resetTrigger, setResetTrigger] = useState(0);
  const [patchedArray, setPatchedArray] = useState([]);
  const dispatch = useDispatch();
  const state = useSelector(selectLocationState);
  const [requestStatus, setRequestStatus] = useState(null);
  //when polygon modal gets submit
  const onModalConfirm = () => {
    if (
      polygonIndex > -1 &&
      locationForm.getFieldValue("locationList").length > 0
    ) {
      let shape = locationForm.getFieldValue([
        "locationList",
        polygonIndex,
        "polygon",
      ]);
      if (shape.length > 0) {
        message.success("Polygon created");
        setModalOpen(false);
        setPolygonIndex(-1);
        setPolygon(null);
      } else {
        message.error("Please mark proper area");
      }
    }
  };

  const onValuesChange = (_, allValues) => {
    // console.log("Updated Form Values:", allValues.locationList);
  };

  const handleSelect = (isoCode, index) => {
    let previousArr = locationForm.getFieldValue("contacts") || [];
    if (Array.isArray(previousArr) && previousArr.length > 0 && index > -1) {
      const updatedContacts = [...previousArr];
      updatedContacts[index] = {
        ...updatedContacts[index],
        contact_phone_number: isoCode,
      };
      locationForm.setFieldsValue({ contacts: updatedContacts });
    }
  };

  //Get Call for fetech all added locations
  // useEffect(() => {
  //   fetchLocations();
  // }, []);

  //store dispatch for couriers
  useEffect(() => {
    if (dispatch) {
      dispatch(fetchAllLocations({ token: token, toggle: false }));
    }
  }, [dispatch]);

  //setting data from store
  useEffect(() => {
    if (state) {
      setRequestStatus(state?.status ? state.status : null);

      if (state?.locationList.length > 0) {
        let arr = state?.locationList;
        if (arr.length > 0) {
          const newArray = arr.map((item) => ({
            ...item, // Spread the existing properties of the object
            contact_name: item.key_contact_name,
            contact_email: item.key_contact_email,
            contact_phone_number: item.key_contact_phone_number, // Add key_name as 'name'
          }));
          setPatchedArray(newArray);
        }
      }
    }
  }, [state]);

  useEffect(() => {
    if (patchedArray.length > 0) {
      locationForm.setFieldsValue({
        locationList: patchedArray,
      });
    }
  }, [patchedArray]);

  // const fetchLocations = () => {
  //   showSpin();
  //   GetLocations(token)
  //     .then((res) => {
  //       const data = res?.data ? res.data : null;
  //       if (data) {
  //         if (data?.data?.is_success) {
  //           let arr = data?.data?.data.length > 0 ? data?.data?.data : [];
  //           if (arr.length > 0) {
  //             const newArray = arr.map(item => ({
  //               ...item,                // Spread the existing properties of the object
  //               contact_name: item.key_contact_name,
  //               contact_email: item.key_contact_email,
  //               contact_phone_number: item.key_contact_phone_number     // Add key_name as 'name'
  //             }));

  //             setPatchedArray(newArray);

  //           }
  //         } else {
  //           message.error(data?.data?.message);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       unauthorize(error)
  //     }).finally(() => {
  //       hideSpin();
  //     });
  // }

  //if status is unauthorize
  useEffect(() => {
    if (requestStatus) {
      unauthorize(requestStatus);
    }
  }, [requestStatus]);

  const unauthorize = (status) => {
    if (status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  //ADD Location
  const submitLocations = (model) => {
    AddLocations(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            dispatch(fetchAllLocations({ token: token, toggle: false }));
            onSuccess();
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  useImperativeHandle(ref, () => ({
    completeStep, // Expose the submitProducts method to the parent
  }));

  //when modal opens
  const openMapModal = (index) => {
    setModalOpen(true);
    setModalName("Draw Polygon");
    if (locationForm.getFieldValue("locationList").length > 0) {
      setSelectedLatLng({
        lat: parseFloat(
          locationForm.getFieldValue("locationList")[index].latitude
        ),
        lng: parseFloat(
          locationForm.getFieldValue("locationList")[index].longitude
        ),
      });
      let shape = locationForm.getFieldValue([
        "locationList",
        index,
        "polygon",
      ]);
      if (shape && shape?.length > 0) {
        setPolygon(shape);
      } else {
        setPolygon(null);
      }
    }
    setPolygonIndex(index);
    setResetTrigger((prev) => prev + 1);
  };

  const completeStep = () => {
    locationForm
      .validateFields()
      .then((values) => {
        if (values && Object.keys(values).length > 0) {
          let model = locationForm.getFieldValue("locationList");
          if (model && model?.length > 0) {
            submitLocations(model);
          }
        } else {
          message.error("Please add at least one location");
        }
      })
      .catch((err) => {});
  };

  //when polygon creted this func runs
  const getPolygon = (val) => {
    console.log("polygon val : ", val);
    if (val && val.length > 0) {
      const locationList = locationForm.getFieldValue("locationList");
      if (locationList && locationList.length > 0) {
        const updatedLocationList = [...locationList];
        if (polygonIndex > -1) {
          updatedLocationList[polygonIndex].polygon = val;
        }
        locationForm.setFieldsValue({
          locationList: updatedLocationList,
        });
      }
    }
  };

  //below 3 functions are relative to address search
  const handleAddressPlaceSelect = (place, index) => {
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    setLatLngInLocationList(lat, lng, index);

    const locationList = locationForm.getFieldValue("locationList");
    if (locationList && locationList?.length > 0) {
      const updatedLocationList = [...locationList];
      updatedLocationList[index].address = place.formatted_address;
      locationForm.setFieldsValue({
        locationList: updatedLocationList,
      });
    }
  };

  const setLatLngInLocationList = (lat, lng, ind) => {
    const locationList = locationForm.getFieldValue("locationList");
    if (locationList && locationList?.length > 0) {
      const updatedLocationList = [...locationList];
      updatedLocationList[ind].latitude = lat;
      updatedLocationList[ind].longitude = lng;
      locationForm.setFieldsValue({
        locationList: updatedLocationList,
      });
    }
  };

  const handleAddressChange = (value, index) => {
    if (!value) {
      setLatLngInLocationList("", "", index);
    }
  };

  const handleRemove = (ind) => {
    if (patchedArray.length > 0) {
      // locationForm.setFieldsValue({
      //   locationList: locationForm.getFieldValue("locationList").filter((_, i) => i !== ind),
      // });
      // const updatedItems = patchedArray.filter((_, index) => index !== ind);
      // setPatchedArray(updatedItems);
    }
  };

  return (
    <>
      <div style={{ paddingBottom: "20px" }}>
        <div className="large-steps-content">
          <StepsHeading
            heading="Save your shipping locations"
            text="Save information about where you're shipping to & from so we can provide this information to you when you need it, like when you might need to call a location to reschedule a delivery. You'll be able to add more than one contact per location and edit these details later."
          />
          <Form
            form={locationForm}
            name="locationsFormList"
            layout="vertical"
            onValuesChange={onValuesChange}
          >
            <Form.List
              name="locationList" // Ensure name is provided for the list
              initialValue={[
                {
                  name: "",
                  address: "",
                  contact_name: "",
                  contact_email: "",
                  contact_phone_number: "",
                  map: false,
                  latitude: "",
                  longitude: "",
                  polygon: [],
                  contacts: [
                    { key: "", name: "", email: "", phone_number: "" },
                  ],
                },
              ]}
            >
              {(fields, { add, remove }) => (
                <Row>
                  <Col span={24}>
                    <>
                      {fields.map((field, index) => (
                        <Row
                          gutter={24}
                          style={{
                            gridGap: "16px 0",
                            padding: "28px 0px",
                            borderBottom: "1px solid rgba(5, 5, 5, 0.1)",
                          }}
                          key={index}
                        >
                          <Col xxl={4} xl={4} lg={5} md={6} sm={12} xs={24}>
                            <Form.Item
                              label={
                                index === 0 ? (
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                    }}
                                  >
                                    Location Name
                                  </span>
                                ) : (
                                  ""
                                )
                              }
                              name={[index, "name"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter location name",
                                },
                                {
                                  pattern:
                                    /^(?=.*[A-Za-zÀ-ÖØ-öø-ÿ])[A-Za-zÀ-ÖØ-öø-ÿ0-9\s.'\-()]{2,100}$/,
                                  message:
                                    "Name must include at least one letter and only valid characters",
                                },
                              ]}
                              style={{ marginBottom: "0" }}
                              labelCol={{
                                style: {
                                  marginBottom: index === 0 ? "10px" : "0", // Add space between label and input for index 0
                                },
                              }}
                            >
                              <CustomInput
                                placeholder="City Hospital"
                                height="36px"
                                border="0px"
                                bgColor="#F3F3F3"
                                textColor="#5E5E5E"
                                borderRadius="8px"
                                placeholderColor="#5E5E5E"
                                lineHeight="38px"
                              />
                            </Form.Item>
                          </Col>

                          <Col xxl={6} xl={6} lg={8} md={9} sm={12} xs={24}>
                            <Form.Item
                              label={
                                index === 0 ? (
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                    }}
                                  >
                                    Address
                                  </span>
                                ) : (
                                  ""
                                )
                              }
                              name={[index, "address"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter address",
                                },
                              ]}
                              style={{ marginBottom: "0" }}
                              labelCol={{
                                style: {
                                  marginBottom: index === 0 ? "10px" : "0",
                                },
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-end",
                                }}
                              >
                                <AutoComplete
                                  value={locationForm.getFieldValue([
                                    "locationList",
                                    index,
                                    "address",
                                  ])}
                                  style={{
                                    flexGrow: 1,
                                    boxShadow: "none",
                                    height: "36px",
                                    backgroundColor: "#F3F3F3",
                                    color: "#5E5E5E",
                                    borderRadius: "8px",
                                  }}
                                  options={options}
                                  onSelect={(value) => {
                                    if (!value) {
                                      console.error("Invalid place ID");
                                      return;
                                    }

                                    const serviceDiv =
                                      document.createElement("div");
                                    const service =
                                      new window.google.maps.places.PlacesService(
                                        serviceDiv
                                      );

                                    service.getDetails(
                                      { placeId: value },
                                      (place, status) => {
                                        if (
                                          status ===
                                          window.google.maps.places
                                            .PlacesServiceStatus.OK
                                        ) {
                                          // Place details fetched successfully
                                          handleAddressPlaceSelect(
                                            place,
                                            index
                                          );
                                        } else {
                                          // Log error if the status is not OK
                                          console.error(
                                            "Failed to fetch place details:",
                                            status
                                          );
                                        }
                                      }
                                    );
                                  }}
                                  onSearch={(text) => {
                                    if (!text) {
                                      console.error("Empty search text");
                                      return;
                                    }

                                    const service =
                                      new window.google.maps.places.AutocompleteService();

                                    service.getPlacePredictions(
                                      { input: text },
                                      (predictions, status) => {
                                        if (
                                          status ===
                                            window.google.maps.places
                                              .PlacesServiceStatus.OK &&
                                          predictions
                                        ) {
                                          setOptions(
                                            predictions.map((prediction) => ({
                                              label: prediction.description,
                                              value: prediction.place_id,
                                            }))
                                          );
                                        } else {
                                          // Log error if the status is not OK
                                          console.error(
                                            "Failed to fetch predictions:",
                                            status
                                          );
                                        }
                                      }
                                    );
                                  }}
                                  onChange={(value) =>
                                    handleAddressChange(value, index)
                                  }
                                  placeholder="Start typing an address..."
                                />

                                <div
                                  style={{
                                    height: "fit-content",
                                    marginLeft: "8px",
                                  }}
                                >
                                  <CustomButton
                                    isFormValid={
                                      !(
                                        locationForm.getFieldValue([
                                          "locationList",
                                          index,
                                          "latitude",
                                        ]) &&
                                        locationForm.getFieldValue([
                                          "locationList",
                                          index,
                                          "longitude",
                                        ])
                                      )
                                    }
                                    image={EditLocation}
                                    iconPosition={"left"}
                                    border="none"
                                    width="36px"
                                    height="36px"
                                    borderRadius="50%"
                                    bgColor="#f5f5f5"
                                    color="#000"
                                    boxShadow="none"
                                    onClick={() => openMapModal(index)}
                                    padding={"0"}
                                  />
                                </div>
                              </div>
                            </Form.Item>
                          </Col>

                          <Form.List name={[field.name, "contacts"]}>
                            {(contactFields, { add }) => {
                              if (contactFields.length === 0) {
                                add();
                              }

                              const contactValues =
                                locationForm.getFieldValue([
                                  "locationList",
                                  field.name,
                                  "contacts",
                                ]) || [];

                              const firstPrimaryIndex = contactValues.findIndex(
                                (contact) =>
                                  contact?.is_primary_contact === true
                              );
                              const newarry =
                                firstPrimaryIndex !== -1
                                  ? contactFields[firstPrimaryIndex]
                                  : contactFields[0] || {};

                              const displayedContact = newarry
                                ? [newarry]
                                : [{}];

                              return displayedContact.map((contactField) => (
                                <>
                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={5}
                                    md={6}
                                    sm={12}
                                    xs={24}
                                  >
                                    <Form.Item
                                      label={
                                        index === 0 ? (
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              width: "100%",
                                              color: "#666",
                                            }}
                                          >
                                            Key Contact Name
                                          </span>
                                        ) : (
                                          ""
                                        )
                                      }
                                      name={[contactField.name, "name"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Please enter contact name",
                                        },
                                        {
                                          pattern: /^[A-Za-z\s'-]+$/,
                                          message:
                                            "Name must contain only letters",
                                        },
                                      ]}
                                      style={{ marginBottom: "0" }}
                                      labelCol={{
                                        style: {
                                          marginBottom:
                                            index === 0 ? "10px" : "0",
                                        },
                                      }}
                                    >
                                      <CustomInput
                                        type="text"
                                        placeholder="e.g. Rory Lee"
                                        height="36px"
                                        border="0px"
                                        bgColor="#F3F3F3"
                                        textColor="#5E5E5E"
                                        borderRadius="8px"
                                        placeholderColor="#5E5E5E"
                                        lineHeight="38px"
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={5}
                                    md={6}
                                    sm={12}
                                    xs={24}
                                  >
                                    <Form.Item
                                      label={
                                        index === 0 ? (
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              color: "#666",
                                            }}
                                          >
                                            Key Contact Email
                                          </span>
                                        ) : (
                                          ""
                                        )
                                      }
                                      name={[contactField.name, "email"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Please enter contact email",
                                        },
                                        {
                                          type: "email",
                                          message: "Enter Valid Email Only",
                                        },
                                      ]}
                                      style={{ marginBottom: "0" }}
                                      labelCol={{
                                        style: {
                                          marginBottom:
                                            index === 0 ? "10px" : "0",
                                        },
                                      }}
                                    >
                                      <CustomInput
                                        placeholder="e.g. name@abc.com"
                                        height="36px"
                                        border="0px"
                                        bgColor="#F3F3F3"
                                        textColor="#5E5E5E"
                                        borderRadius="8px"
                                        placeholderColor="#5E5E5E"
                                        lineHeight="38px"
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col
                                    xxl={5}
                                    xl={5}
                                    lg={5}
                                    md={6}
                                    sm={12}
                                    xs={24}
                                  >
                                    <Form.Item
                                      label={
                                        index === 0 ? (
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              color: "#666",
                                            }}
                                          >
                                            Key Contact Phone
                                          </span>
                                        ) : (
                                          ""
                                        )
                                      }
                                      name={[contactField.name, "phone_number"]}
                                      // rules={[
                                      //   {
                                      //     validator: (_, value) => {
                                      //       if (!value || value.trim() === "") {
                                      //         return Promise.resolve();  
                                      //       }
                                      //       const digitsOnly = value.replace(/\D/g, "");
                                      
                                      //       if (digitsOnly.length >= 10) {
                                      //         return Promise.resolve();
                                      //       }
                                      
                                      //       return Promise.reject(new Error("Please enter a valid phone number"));
                                      //     },
                                      //   },
                                      // ]}

                                       rules={[
                                                        {
                                                          validator: (_, value) => {
                                                            if (!value || value.trim() === '') {
                                                              return Promise.resolve(); // Optional
                                                            }
                                                            try {
                                                              if (isValidPhoneNumber(value)) {
                                                                return Promise.resolve();
                                                              } else {
                                                                return Promise.reject(new Error("Invalid phone number"));
                                                              }
                                                            } catch {
                                                              return Promise.reject(new Error("Invalid phone number"));
                                                            }
                                                          },
                                                        },
                                                      ]}
                                      
                                      
                                      style={{ marginBottom: "0" }}
                                      labelCol={{
                                        style: {
                                          marginBottom:
                                            index === 0 ? "10px" : "0",
                                        },
                                      }}
                                    >
                                      <PhoneInput
                                        country={"us"}
                                        value={locationForm.getFieldValue([
                                          "locationList",
                                          field.name,
                                          "contacts",
                                          contactField.name,
                                          "phone_number",
                                        ])}
                                        onChange={(
                                          value,
                                          countryData,
                                          e,
                                          formattedValue
                                        ) => {
                                          locationForm.setFieldsValue({
                                            locationList: locationForm
                                              .getFieldValue("locationList")
                                              .map((item, idx) => {
                                                if (idx === field.name) {
                                                  return {
                                                    ...item,
                                                    contacts: item.contacts.map(
                                                      (contact, contactIdx) => {
                                                        if (
                                                          contactIdx ===
                                                          contactField.name
                                                        ) {
                                                          return {
                                                            ...contact,
                                                            phone_number:
                                                              formattedValue,
                                                          };
                                                        }
                                                        return contact;
                                                      }
                                                    ),
                                                  };
                                                }
                                                return item;
                                              }),
                                          });
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                </>
                              ));
                            }}
                          </Form.List>

                          <Col span={1} className="location-action-btn">
                            <Form.Item
                              label={"action"}
                              name={[index, "action"]}
                              style={{ marginBottom: "0" }}
                              labelCol={{
                                style: {
                                  marginBottom: index === 0 ? "10px" : "0",
                                  display: index === 0 ? "auto" : "none",
                                  visibility: "hidden",
                                },
                              }}
                            >
                              <CloseOutlined onClick={() => remove(index)} />
                            </Form.Item>
                          </Col>
                          {/* Hidden fields */}
                          <Form.Item
                            label=""
                            name={[index, "latitude"]}
                            style={{ marginBottom: "0", display: "none" }}
                          ></Form.Item>
                          <Form.Item
                            label=""
                            name={[index, "longitude"]}
                            style={{ marginBottom: "0", display: "none" }}
                          ></Form.Item>
                          <Form.Item
                            label=""
                            name={[index, "polygon"]}
                            style={{ marginBottom: "0", display: "none" }}
                          ></Form.Item>
                          <Form.Item
                            label=""
                            name={[index, "contacts"]}
                            style={{ marginBottom: "0", display: "none" }}
                          ></Form.Item>
                        </Row>
                      ))}
                    </>
                  </Col>
                  <Col
                    span={18}
                    offset={0}
                    className="info-div-add remove-margin-xs"
                  >
                    <AddItemButton
                      text="Add Another"
                      onClick={() => add({ contacts: [{}] })}
                    />
                  </Col>
                </Row>
              )}
            </Form.List>
          </Form>
        </div>
      </div>

      <CustomModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalTitle={`${modalName}`}
        modalText=""
        p
        modalSize={680}
        buttonText1={"Cancel"}
        buttonText2={"Submit"}
        isFormValid={isFormValid}
        onConfirmClick={onModalConfirm}
      >
        <Map
          onPolygonCompleted={getPolygon}
          selectedLatLng={selectedLatLng}
          polygon={polygon}
          resetTrigger={resetTrigger}
        />
      </CustomModal>
    </>
  );
});

export default Locations;
